import React, { createContext, useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Loader from './Loader'; // Import the Loader component

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(i18n.language);
  const [direction, setDirection] = useState('ltr');
  const [loading, setLoading] = useState(false);
  const prevLanguageRef = useRef(language);

  const loadCSS = (direction) => {
    if (direction === 'rtl') {
      import('../styles/ar/layout-ar.css').then(() => {
        document.body.classList.remove('ltr');
        document.body.classList.add('rtl');
      });
    } else {
      import('../styles/en/layout-en.css').then(() => {
        document.body.classList.remove('rtl');
        document.body.classList.add('ltr');
      });
    }
  };

  useEffect(() => {
    const setDirectionBasedOnLanguage = (lng) => {
      const rtlLanguages = ['ar', 'he', 'fa', 'ur'];
      const newDirection = rtlLanguages.includes(lng) ? 'rtl' : 'ltr';
      setDirection(newDirection);
      loadCSS(newDirection);
    };

    if (prevLanguageRef.current !== language) {
      setDirectionBasedOnLanguage(language);
      prevLanguageRef.current = language;
    }

    const handleLanguageChange = (lng) => {
      setLanguage(lng);
      setDirectionBasedOnLanguage(lng);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n, language]);

  const changeLanguage = (lng) => {
    setLoading(true);
    i18n.changeLanguage(lng).then(() => {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    });
  };

  const toggleDirection = () => {
    setDirection((prevDirection) => {
      const newDirection = prevDirection === 'ltr' ? 'rtl' : 'ltr';
      loadCSS(newDirection);
      return newDirection;
    });
  };

  return (
    <LanguageContext.Provider value={{ language, direction, changeLanguage, toggleDirection }}>
      <div dir={direction}>
        {loading && <Loader />} {/* Show loader when loading is true */}
        {children}
      </div>
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
